export const TESTAB_MODULE_NAME = 'testAb';

export const TEST_IDS = {
  disambiguationList: '1535384459',
};



// WEBPACK FOOTER //
// ./app/TestAb/constants.js